import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_RECOMMENDATION_PREFERENCE from './GetRecommendationPreferencesStatus.graphql';

export const useGetRecommendationPreferencesStatus = (options) => {
  const [queryResults, queryAction] = useCustomQuery(
    GET_RECOMMENDATION_PREFERENCE,
    {
      ...options,
      url: config('GRAPHQL_API_URL'),
      requestPolicy: 'no-cache',
      accessor: 'recommendationPreferencesStatus',
      onCompleted: (result) => {
        if (options?.handleSuccess) {
          options?.handleSuccess();
        }
        return result;
      },
      onError: (error) => {
        if (options?.handleError) {
          options?.handleError();
        }
        throw error;
      },
    }
  );

  return [queryResults, queryAction];
};
